import { Box, Button, Container, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box mt={8}>
        <Stack spacing={3} alignItems="center">
          <Typography variant="h2">404</Typography>

          <Typography variant="h6" textAlign="center">
            페이지를 찾을 수 없습니다 💣
          </Typography>

          <Typography variant="body2" color="text.secondary" textAlign="center">
            주소가 잘못되었거나 삭제된 페이지입니다.
          </Typography>

          <Button variant="contained" onClick={() => navigate("/")}>
            홈으로 돌아가기
          </Button>
        </Stack>
      </Box>
    </Container>
  );
}
